function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#002A33;}\n\t.st2{clip-path:url(#SVGID_00000090292577783718509670000013022099316924331676_);}\n\t.st3{fill:#6CB9B2;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#E4E5E5;}\n\t.st5{fill:#7C531B;}\n\t.st6{fill:#563A14;}\n\t.st7{fill:#795421;}\n\t.st8{fill:#A97D42;}\n\t.st9{fill:#5D3E13;}\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:#5D3E13;}\n\t.st11{fill:#D89C3B;}\n\t.st12{fill-rule:evenodd;clip-rule:evenodd;fill:#ECB23A;}\n\t.st13{fill-rule:evenodd;clip-rule:evenodd;fill:#F4BC43;}\n\t.st14{fill-rule:evenodd;clip-rule:evenodd;fill:#D89C3B;}\n\t.st15{fill-rule:evenodd;clip-rule:evenodd;fill:#FDEF35;}\n\t.st16{fill:#F4BC43;}\n\t.st17{fill:#D6903B;}\n\t.st18{fill:#FCD04B;}\n\t.st19{fill-rule:evenodd;clip-rule:evenodd;fill:#744F1C;}\n\t.st20{fill-rule:evenodd;clip-rule:evenodd;fill:#442D0E;}\n\t.st21{fill-rule:evenodd;clip-rule:evenodd;fill:#C58F42;}\n\t.st22{fill-rule:evenodd;clip-rule:evenodd;fill:#BF833D;}\n\t.st23{fill:#BF833D;}\n\t.st24{fill:#E5A840;}\n\t.st25{fill-rule:evenodd;clip-rule:evenodd;fill:#F7E04B;}\n\t.st26{fill-rule:evenodd;clip-rule:evenodd;fill:#E8168B;}\n\t.st27{fill-rule:evenodd;clip-rule:evenodd;fill:#BB2971;}\n\t.st28{fill-rule:evenodd;clip-rule:evenodd;fill:#E76393;}\n\t.st29{fill-rule:evenodd;clip-rule:evenodd;fill:#5BC4CE;}\n\t.st30{fill-rule:evenodd;clip-rule:evenodd;fill:#90D7F5;}\n\t.st31{fill-rule:evenodd;clip-rule:evenodd;fill:#B9D9E3;}\n\t.st32{fill-rule:evenodd;clip-rule:evenodd;fill:#6BC2E6;}\n\t.st33{fill-rule:evenodd;clip-rule:evenodd;fill:#1BA7DF;}\n\t.st34{fill-rule:evenodd;clip-rule:evenodd;fill:#1482C4;}\n\t.st35{fill-rule:evenodd;clip-rule:evenodd;fill:#FAC63C;}\n\t.st36{fill:#FAC63C;}\n\t.st37{fill:#FDEF35;}\n\t.st38{fill-rule:evenodd;clip-rule:evenodd;fill:#B82B7F;}\n\t.st39{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st40{fill-rule:evenodd;clip-rule:evenodd;fill:#9CC84C;}\n\t.st41{fill-rule:evenodd;clip-rule:evenodd;fill:#76BD4D;}\n\t.st42{fill-rule:evenodd;clip-rule:evenodd;fill:#D2DC59;}\n\t.st43{fill-rule:evenodd;clip-rule:evenodd;fill:#128A4C;}\n\t.st44{fill-rule:evenodd;clip-rule:evenodd;fill:#C0C541;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 139.9,
  cy: 139.9,
  r: 131.4
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M139.9,279.7C62.7,279.7,0,217,0,139.9S62.7,0,139.9,0s139.9,62.7,139.9,139.9S217,279.7,139.9,279.7z  M139.9,17C72.1,17,17,72.1,17,139.9s55.1,122.9,122.9,122.9s122.9-55.1,122.9-122.9S207.6,17,139.9,17z"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
  id: "SVGID_1_",
  cx: 140,
  cy: 140.4,
  rx: 123.1,
  ry: 123.2
}));

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: -22.6,
  y: -9.6,
  className: "st3",
  width: 319.4,
  height: 320.9
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M53.6,237.9c-1.1,0.8-1.9,2.2-1.9,3.7c0,2.5,2,4.5,4.5,4.5s4.5-2,4.5-4.5c0-1.5-0.7-2.9-1.9-3.7 c-0.1-0.7-0.5-1.2-1-1.6v-7.7h1.3v-3.7h-1.3v-2.1c0-0.9-0.7-1.6-1.6-1.6l0,0c-0.9,0-1.6,0.7-1.6,1.6v2c-0.2-0.1-0.4-0.2-0.6-0.4 c-0.3-0.4-0.6-0.8-0.6-1.4v-8.1c0-0.5,0.2-1,0.6-1.4c0.3-0.4,0.8-0.6,1.3-0.6h3.8v-3.7h-3.8c-1.5,0-3,0.6-4,1.6 c-1,1-1.6,2.4-1.6,4v8.1c0,1.6,0.6,3,1.6,4c0.8,0.8,2,1.4,3.2,1.6v7.6C54.1,236.6,53.8,237.2,53.6,237.9L53.6,237.9L53.6,237.9z  M256,237.9c-0.1-0.7-0.5-1.3-1.1-1.7v-7.6c1.2-0.2,2.3-0.8,3.2-1.6c1-1,1.6-2.4,1.6-4v-8.1c0-1.6-0.6-3-1.6-4 c-1-1-2.4-1.6-4-1.6h-3.8v3.7h3.8c0.5,0,1,0.2,1.3,0.6c0.4,0.4,0.6,0.8,0.6,1.4v8.1c0,0.5-0.2,1-0.6,1.4 c-0.2,0.2-0.4,0.3-0.6,0.4v-2c0-0.9-0.7-1.6-1.6-1.6l0,0c-0.9,0-1.6,0.7-1.6,1.6v2.1h-1.3v3.7h1.3v7.7c-0.5,0.4-0.9,1-1,1.6 c-1.1,0.8-1.9,2.2-1.9,3.7c0,2.5,2,4.5,4.5,4.5s4.5-2,4.5-4.5C257.9,240.1,257.1,238.8,256,237.9L256,237.9z"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 47.9,
  y: 176.9,
  className: "st5",
  width: 183.9,
  height: 86
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 67.3,
  y: 198.7,
  className: "st6",
  width: 2.3,
  height: 64.2
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 42.7,
  y: 196.4,
  className: "st7",
  width: 194.4,
  height: 2.3
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 42.7,
  y: 262.9,
  className: "st8",
  width: 194.4,
  height: 2.3
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 229.6,
  y: 198.7,
  className: "st9",
  width: 2.3,
  height: 64.2
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 69.6,
  y: 198.7,
  className: "st9",
  width: 4.5,
  height: 64.2
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M237.1,195.1v-18.2h-18.2C220.9,186,228,193.1,237.1,195.1z"
});

var _ref14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 69.6,
  y: 242.2,
  className: "st9",
  width: 140.5,
  height: 2.6
}), /*#__PURE__*/React.createElement("rect", {
  x: 69.6,
  y: 219.9,
  className: "st9",
  width: 140.5,
  height: 2.6
}));

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 69.6,
  y: 198.7,
  className: "st9",
  width: 140.5,
  height: 4.6
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M42.7,195.1v-11.8h-2.1v-2.6h2.1v-3.9h18.2c-0.3,1.3-0.7,2.6-1.2,3.9h179.4v2.6H58.5 C55.2,189.2,49.5,193.6,42.7,195.1z"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 40.7,
  y: 174.8,
  className: "st11",
  width: 198.5,
  height: 5.9
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M239.1,192.7v-17.9h-17.9C221.3,184.7,229.3,192.7,239.1,192.7L239.1,192.7z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M239.1,190v-15.3H224C224,183.2,230.8,190,239.1,190z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M232.4,184.2c1.7,0,3-1.4,3-3s-1.4-3-3-3s-3,1.4-3,3S230.8,184.2,232.4,184.2z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M231.9,182.2c0.9,0,1.6-0.7,1.6-1.6s-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6S231,182.2,231.9,182.2z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M40.7,192.7v-17.9h17.8C58.5,184.7,50.5,192.7,40.7,192.7L40.7,192.7z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M40.7,190v-15.3h15.2C55.8,183.2,49,190,40.7,190z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M42,174.8h13.8c0,3.9-1.4,7.4-3.8,10.1L42,174.8z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M47.4,184.2c1.7,0,3-1.4,3-3s-1.3-3-3-3s-3,1.4-3,3S45.7,184.2,47.4,184.2z"
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  x: 74.2,
  y: 218.2,
  className: "st7",
  width: 136,
  height: 1.6
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M46.8,182.3c0.9,0,1.6-0.7,1.6-1.6s-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6S45.9,182.3,46.8,182.3z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M42.7,266.4v18.2h18.2C58.9,275.6,51.8,268.4,42.7,266.4z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M40.7,268.8v17.9h17.8C58.5,276.9,50.5,268.8,40.7,268.8z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M40.7,271.5v15.3h15.2C55.8,278.3,49,271.5,40.7,271.5z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M47.4,283.3c1.7,0,3-1.4,3-3s-1.3-3-3-3s-3,1.4-3,3S45.7,283.3,47.4,283.3z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M46.7,281.5c0.9,0,1.6-0.7,1.6-1.6s-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6S45.8,281.5,46.7,281.5z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M231.9,213.1h1.8c1,0,1.8,0.8,1.8,1.8V242c0,1-0.8,1.8-1.8,1.8h-1.8V213.1L231.9,213.1z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M231.9,213.1h1.8c1,0,1.8,0.8,1.8,1.8V231c0,1-0.8,1.8-1.8,1.8h-1.8V213.1L231.9,213.1z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M235.5,218.5h3.8c1.5,0,2.9,0.6,4,1.6c1,1,1.6,2.4,1.6,4v8.1c0,1.6-0.6,3-1.6,4c-1,1-2.4,1.6-4,1.6h-3.8 v-3.7h3.8c0.5,0,1-0.2,1.3-0.6c0.4-0.4,0.6-0.8,0.6-1.4v-8.1c0-0.5-0.2-1-0.6-1.4c-0.4-0.4-0.8-0.6-1.3-0.6h-3.8V218.5 L235.5,218.5z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M235.5,235.6v-1.5h3.8c0.5,0,1-0.2,1.3-0.6c0.4-0.4,0.6-0.8,0.6-1.4v-8.1c0-0.5-0.2-1-0.6-1.4 c-0.4-0.4-0.8-0.6-1.3-0.6h-3.8v-1.5h3.1c1.1,0,2.1,0.4,2.8,1.2s1.2,1.7,1.2,2.8v6.9c0,1.1-0.4,2.1-1.2,2.8 c-0.7,0.7-1.7,1.2-2.8,1.2L235.5,235.6L235.5,235.6z"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M238.4,230.4L238.4,230.4c0.9,0,1.6,0.7,1.6,1.6v19c0,0.9-0.7,1.6-1.6,1.6h0c-0.9,0-1.6-0.7-1.6-1.6v-19 C236.8,231.1,237.5,230.4,238.4,230.4z"
});

var _ref38 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M237.1,266.4v18.2h-18.2C220.9,275.6,228,268.4,237.1,266.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M239.1,268.8v17.9h-17.9C221.3,276.9,229.3,268.8,239.1,268.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M239.1,271.5v15.3H224C224,278.3,230.8,271.5,239.1,271.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M232.4,283.3c1.7,0,3-1.4,3-3s-1.4-3-3-3s-3,1.4-3,3S230.8,283.3,232.4,283.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M231.9,282.5c0.9,0,1.6-0.7,1.6-1.6s-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6S231,282.5,231.9,282.5z"
}));

var _ref39 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M241.1,247.1c1.1,0.8,1.9,2.2,1.9,3.7c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5c0-1.5,0.7-2.9,1.9-3.7 c0.2-1.3,1.3-2.2,2.6-2.2S240.9,245.9,241.1,247.1z"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M238.4,253.2c1.3,0,2.4-1.1,2.4-2.4s-1.1-2.4-2.4-2.4s-2.4,1.1-2.4,2.4S237.1,253.2,238.4,253.2z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M47.9,213.1h-1.8c-1,0-1.8,0.8-1.8,1.8V242c0,1,0.8,1.8,1.8,1.8h1.8V213.1L47.9,213.1z"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M47.9,213.1h-1.8c-1,0-1.8,0.8-1.8,1.8V231c0,1,0.8,1.8,1.8,1.8h1.8V213.1L47.9,213.1z"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M44.3,218.5h-3.8c-1.5,0-3,0.6-4,1.6c-1,1-1.6,2.4-1.6,4v8.1c0,1.6,0.6,3,1.6,4c1,1,2.4,1.6,4,1.6h3.8v-3.7 h-3.8c-0.5,0-1-0.2-1.3-0.6c-0.3-0.4-0.6-0.8-0.6-1.4v-8.1c0-0.5,0.2-1,0.6-1.4c0.3-0.4,0.8-0.6,1.3-0.6h3.8V218.5L44.3,218.5z"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M44.3,235.6v-1.5h-3.8c-0.5,0-1-0.2-1.3-0.6c-0.3-0.4-0.6-0.8-0.6-1.4v-8.1c0-0.5,0.2-1,0.6-1.4 c0.3-0.4,0.8-0.6,1.3-0.6h3.8v-1.5h-3.1c-1.1,0-2.1,0.4-2.8,1.2s-1.2,1.7-1.2,2.8v6.9c0,1.1,0.5,2.1,1.2,2.8 c0.7,0.7,1.7,1.2,2.8,1.2L44.3,235.6L44.3,235.6z"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M41.4,230.4L41.4,230.4c0.9,0,1.6,0.7,1.6,1.6v19c0,0.9-0.7,1.6-1.6,1.6l0,0c-0.9,0-1.6-0.7-1.6-1.6v-19 C39.8,231.1,40.5,230.4,41.4,230.4z"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M38.7,247.1c-1.1,0.8-1.9,2.2-1.9,3.7c0,2.5,2,4.5,4.5,4.5s4.5-2,4.5-4.5c0-1.5-0.7-2.9-1.9-3.7 c-0.2-1.3-1.3-2.2-2.7-2.2S38.9,245.9,38.7,247.1z"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M41.4,253.2c1.3,0,2.4-1.1,2.4-2.4s-1.1-2.4-2.4-2.4s-2.4,1.1-2.4,2.4S40,253.2,41.4,253.2z"
});

var _ref48 = /*#__PURE__*/React.createElement("rect", {
  x: 89.6,
  y: 176.9,
  className: "st11",
  width: 13.1,
  height: 21.8
});

var _ref49 = /*#__PURE__*/React.createElement("rect", {
  x: 102.7,
  y: 180.7,
  className: "st9",
  width: 2.4,
  height: 18
});

var _ref50 = /*#__PURE__*/React.createElement("rect", {
  x: 89.6,
  y: 198.7,
  className: "st16",
  width: 13.1,
  height: 64.2
});

var _ref51 = /*#__PURE__*/React.createElement("rect", {
  x: 89.6,
  y: 196.4,
  className: "st17",
  width: 13.1,
  height: 2.3
});

var _ref52 = /*#__PURE__*/React.createElement("rect", {
  x: 89.6,
  y: 262.9,
  className: "st18",
  width: 13.1,
  height: 2.3
});

var _ref53 = /*#__PURE__*/React.createElement("rect", {
  x: 89.6,
  y: 265.2,
  className: "st16",
  width: 13.1,
  height: 15.1
});

var _ref54 = /*#__PURE__*/React.createElement("rect", {
  x: 102.7,
  y: 198.7,
  className: "st9",
  width: 5.2,
  height: 64.2
});

var _ref55 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 174.7,
  y: 176.9,
  className: "st11",
  width: 13.1,
  height: 21.8
}), /*#__PURE__*/React.createElement("rect", {
  x: 187.8,
  y: 180.7,
  className: "st9",
  width: 2.4,
  height: 18
}), /*#__PURE__*/React.createElement("rect", {
  x: 174.7,
  y: 198.7,
  className: "st16",
  width: 13.1,
  height: 64.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 174.7,
  y: 196.4,
  className: "st17",
  width: 13.1,
  height: 2.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 174.7,
  y: 262.9,
  className: "st18",
  width: 13.1,
  height: 2.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 174.7,
  y: 265.2,
  className: "st16",
  width: 13.1,
  height: 15.1
}), /*#__PURE__*/React.createElement("rect", {
  x: 187.8,
  y: 196.4,
  className: "st9",
  width: 2.4,
  height: 84
}));

var _ref56 = /*#__PURE__*/React.createElement("ellipse", {
  className: "st11",
  cx: 181.2,
  cy: 273.3,
  rx: 3,
  ry: 3
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M180.7,274.4c0.9,0,1.6-0.7,1.6-1.6s-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6S179.8,274.4,180.7,274.4z"
});

var _ref58 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M96.2,276.4c1.7,0,3-1.4,3-3s-1.3-3-3-3s-3,1.4-3,3S94.5,276.4,96.2,276.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M95.6,274.4c0.9,0,1.6-0.7,1.6-1.6s-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6S94.8,274.4,95.6,274.4z"
}));

var _ref59 = /*#__PURE__*/React.createElement("rect", {
  x: 40.7,
  y: 83.2,
  className: "st9",
  width: 198.5,
  height: 91.6
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  className: "st19",
  d: "M239.1,169.2V88.8c-14.4,4.2-25.2,20.6-25.2,40.2S224.7,165,239.1,169.2z"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  className: "st20",
  d: "M40.7,88.8v80.3c14.4-4.1,25.2-20.6,25.2-40.2S55.1,93,40.7,88.8z"
});

var _ref62 = /*#__PURE__*/React.createElement("rect", {
  x: 53.5,
  y: 94.2,
  className: "st7",
  width: 172.9,
  height: 2.2
});

var _ref63 = /*#__PURE__*/React.createElement("rect", {
  x: 51.4,
  y: 83.2,
  className: "st9",
  width: 2,
  height: 91.6
});

var _ref64 = /*#__PURE__*/React.createElement("rect", {
  x: 40.7,
  y: 174.8,
  className: "st16",
  width: 198.5,
  height: 2.1
});

var _ref65 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M72.3,170.1h22.1c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5h6c0.4,0,0.8,1,0.8,2.3l0,0c0,1.3-0.4,2.3-0.8,2.3 h-6c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5H69.3c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5h-6c-0.5,0-0.8-1-0.8-2.3l0,0 c0-1.3,0.4-2.3,0.8-2.3h6c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5C69.3,170.1,72.3,170.1,72.3,170.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M104.2,173.2c-0.1,0.9-0.4,1.6-0.8,1.6h-6c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5H69.3 c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5h-6c-0.4,0-0.7-0.7-0.8-1.6H104.2L104.2,173.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M68.8,173.7c-0.3-0.2-0.6-0.4-1-0.4s-0.7,0.1-1,0.4v-2.4c0.3,0.2,0.6,0.4,1,0.4s0.7-0.1,1-0.4V173.7 L68.8,173.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M94.9,171.2c0.3,0.2,0.6,0.4,1,0.4s0.7-0.1,1-0.4v2.4c-0.3-0.2-0.6-0.4-1-0.4s-0.7,0.1-1,0.4V171.2z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 90.1,
  y: 170.1,
  className: "st23",
  width: 2,
  height: 4.6
}), /*#__PURE__*/React.createElement("rect", {
  x: 72.1,
  y: 170.1,
  className: "st23",
  width: 2,
  height: 4.6
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M188.4,170.1h22.1c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5h6c0.4,0,0.8,1,0.8,2.3l0,0 c0,1.3-0.4,2.3-0.8,2.3h-6c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5h-25.1c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5h-6 c-0.4,0-0.8-1-0.8-2.3l0,0c0-1.3,0.4-2.3,0.8-2.3h6c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5H188.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M220.3,173.2c-0.1,0.9-0.4,1.6-0.8,1.6h-6c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5h-25.1 c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5h-6c-0.4,0-0.7-0.7-0.8-1.6H220.3L220.3,173.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M184.9,173.7c-0.3-0.2-0.6-0.4-1-0.4s-0.7,0.1-1,0.4v-2.4c0.3,0.2,0.6,0.4,1,0.4s0.7-0.1,1-0.4V173.7 L184.9,173.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M211,171.2c0.3,0.2,0.6,0.4,1,0.4s0.7-0.1,1-0.4v2.4c-0.3-0.2-0.6-0.4-1-0.4s-0.7,0.1-1,0.4V171.2z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 206.2,
  y: 170.1,
  className: "st23",
  width: 2,
  height: 4.6
}), /*#__PURE__*/React.createElement("rect", {
  x: 188.2,
  y: 170.1,
  className: "st23",
  width: 2,
  height: 4.6
})));

var _ref66 = /*#__PURE__*/React.createElement("rect", {
  x: 131.3,
  y: 231.5,
  className: "st11",
  width: 17.2,
  height: 3.9
});

var _ref67 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M124.3,235.6c-1.1-0.2-1.9-1.2-1.9-2.4s0.8-2.1,1.9-2.4c0-0.6,0.5-1.1,1.2-1.1c0.3,0,0.5,0.1,0.7,0.2 c0.8-0.8,1.9-1.3,3.2-1.3c2.5,0,4.5,2,4.5,4.6s-2,4.6-4.5,4.6c-1.2,0-2.3-0.5-3.1-1.2c-0.2,0.2-0.5,0.3-0.8,0.3 C124.9,236.8,124.3,236.3,124.3,235.6L124.3,235.6L124.3,235.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M155.6,235.6c1.1-0.2,1.9-1.2,1.9-2.4s-0.8-2.1-1.9-2.4c0-0.6-0.5-1.1-1.2-1.1c-0.3,0-0.5,0.1-0.7,0.2 c-0.8-0.8-1.9-1.3-3.2-1.3c-2.5,0-4.5,2-4.5,4.6s2,4.6,4.5,4.6c1.2,0,2.3-0.5,3.1-1.2c0.2,0.2,0.5,0.3,0.8,0.3 C155.1,236.8,155.6,236.3,155.6,235.6L155.6,235.6L155.6,235.6z"
}));

var _ref68 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M150.5,235.4c1.2,0,2.2-1,2.2-2.2s-1-2.2-2.2-2.2s-2.2,1-2.2,2.2S149.3,235.4,150.5,235.4z"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M129.8,235.4c1.2,0,2.2-1,2.2-2.2s-1-2.2-2.2-2.2s-2.2,1-2.2,2.2S128.5,235.4,129.8,235.4z"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M121.4,83.2h37v-1.6c0-0.8-0.7-1.6-1.5-1.6H123c-0.8,0-1.5,0.7-1.5,1.6V83.2z"
});

var _ref71 = /*#__PURE__*/React.createElement("rect", {
  x: 130.5,
  y: 78.4,
  className: "st16",
  width: 18.8,
  height: 4.8
});

var _ref72 = /*#__PURE__*/React.createElement("rect", {
  x: 130.5,
  y: 81.4,
  className: "st24",
  width: 18.8,
  height: 1.8
});

var _ref73 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 134.3,
  y: 78.4,
  className: "st23",
  width: 2.6,
  height: 4.8
}), /*#__PURE__*/React.createElement("rect", {
  x: 142.9,
  y: 78.4,
  className: "st23",
  width: 2.6,
  height: 4.8
}));

var _ref74 = /*#__PURE__*/React.createElement("polygon", {
  className: "st13",
  points: "221.3,80.6 239.1,80.6 241.7,80.6 241.7,98.6 239.1,98.6 239.1,83.2 221.3,83.2  "
});

var _ref75 = /*#__PURE__*/React.createElement("polygon", {
  className: "st13",
  points: "58.5,80.6 40.7,80.6 38.1,80.6 38.1,98.6 40.7,98.6 40.7,83.2 58.5,83.2  "
});

var _ref76 = /*#__PURE__*/React.createElement("polygon", {
  className: "st25",
  points: "44.3,80.6 40.7,80.6 38.1,80.6 38.1,98.6 40.7,98.6 40.7,83.2 46.9,83.2  "
});

var _ref77 = /*#__PURE__*/React.createElement("rect", {
  x: 102.7,
  y: 262.3,
  className: "st9",
  width: 2.4,
  height: 18
});

var _ref78 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st26",
  points: "118.5,146.6 115.4,157.6 112.3,168.6 101.3,165.5 90.3,162.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st27",
  points: "111.5,150.5 111.9,159.6 112.3,168.6 104.8,163.5 97.4,158.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st27",
  points: "113.1,145 118.5,146.6 90.3,162.4 91.9,156.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st26",
  points: "97.4,158.4 94.6,157.6 91.9,156.9 91.1,159.6 90.3,162.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st26",
  points: "97.4,158.4 98.2,155.7 98.9,152.9 101.7,153.7 104.4,154.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st26",
  points: "111.5,150.5 108.7,149.7 106,148.9 105.2,151.7 104.4,154.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st26",
  points: "111.5,150.5 112.3,147.8 113.1,145 115.8,145.8 118.5,146.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st27",
  points: "97.4,158.4 96.6,161.2 95.8,164 93.1,163.2 90.3,162.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st28",
  points: "97.4,158.4 100.1,159.2 102.9,160 103.7,157.2 104.4,154.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st28",
  points: "111.5,150.5 110.7,153.3 109.9,156 107.2,155.3 104.4,154.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st27",
  points: "111.5,150.5 114.2,151.3 117,152.1 117.8,149.3 118.5,146.6  "
}));

var _ref79 = /*#__PURE__*/React.createElement("rect", {
  x: 187.8,
  y: 198.7,
  className: "st9",
  width: 5.2,
  height: 64.2
});

var _ref80 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st29",
  points: "158,152.2 160.2,155.6 162.5,159 160.7,162.7 158.8,166.4 154.8,166.6 150.7,166.9 148.4,163.4  146.2,160 148,156.4 149.8,152.7 153.9,152.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st30",
  points: "156.6,154.9 158,157.1 159.4,159.2 158.3,161.5 157.1,163.8 154.6,164 152.1,164.1 150.6,162  149.2,159.8 150.4,157.5 151.5,155.2 154.1,155.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st31",
  points: "149.8,152.7 151.5,155.2 156.6,154.9 158,152.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st32",
  points: "149.8,152.7 146.2,160 149.2,159.8 151.5,155.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st32",
  points: "162.5,159 159.4,159.2 156.6,154.9 158,152.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st33",
  points: "162.5,159 158.8,166.4 157.1,163.8 159.4,159.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st33",
  points: "146.2,160 149.2,159.8 152.1,164.1 150.7,166.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st34",
  points: "158.8,166.4 157.1,163.8 152.1,164.1 150.7,166.9  "
}));

var _ref81 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M156.7,158c-6.7,0-12.2,5.5-12.2,12.3c0,1.6,0.3,3.1,0.9,4.5h22.7c0.6-1.4,0.9-2.9,0.9-4.5 C168.9,163.5,163.4,158,156.7,158L156.7,158z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st35",
  d: "M156.7,159.3c-6,0-10.9,4.9-10.9,11c0,1.6,0.3,3.1,1,4.5h20c0.6-1.4,1-2.9,1-4.5 C167.7,164.2,162.8,159.3,156.7,159.3L156.7,159.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M166.1,167.4c-1.6-5.2-7-8.1-12.1-6.6c-5.2,1.6-8.1,7-6.5,12.2L166.1,167.4L166.1,167.4z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M176.5,153.4c-6.7,0-12.2,5.5-12.2,12.3c0,3.6,1.6,6.9,4.1,9.1h16.2c2.5-2.2,4.1-5.5,4.1-9.1 C188.7,158.9,183.2,153.4,176.5,153.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st35",
  d: "M176.5,154.6c-6,0-10.9,4.9-10.9,11c0,3.8,1.9,7.2,4.9,9.1h12.1c2.9-2,4.9-5.3,4.9-9.1 C187.4,159.6,182.5,154.6,176.5,154.6L176.5,154.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M185.8,162.8c-1.6-5.2-7-8.1-12.1-6.6c-5.2,1.6-8.1,7-6.5,12.2L185.8,162.8L185.8,162.8z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M192.2,161.5c-6.7,0-12.2,5.5-12.2,12.3c0,0.3,0,0.7,0,1h24.3c0-0.3,0-0.7,0-1 C204.4,167,198.9,161.5,192.2,161.5L192.2,161.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st35",
  d: "M192.2,162.8c-6,0-10.9,4.9-10.9,11c0,0.3,0,0.7,0.1,1h21.8c0-0.3,0.1-0.7,0.1-1 C203.2,167.7,198.3,162.8,192.2,162.8L192.2,162.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M201.6,170.9c-1.6-5.2-7-8.1-12.1-6.6c-4.6,1.4-7.4,5.8-6.9,10.4h6.3L201.6,170.9L201.6,170.9z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M140.8,163.6c-6.4,0-11.6,4.9-12.1,11.2h24.3C152.4,168.5,147.1,163.6,140.8,163.6L140.8,163.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st35",
  d: "M140.8,164.8c-5.7,0-10.4,4.4-10.9,9.9h21.8C151.1,169.2,146.5,164.8,140.8,164.8L140.8,164.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M150.1,173c-1.6-5.2-7-8.1-12.1-6.6c-3.9,1.2-6.5,4.5-6.9,8.3h13.2L150.1,173L150.1,173z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M121.8,158c-6.7,0-12.2,5.5-12.2,12.3c0,1.6,0.3,3.1,0.8,4.5h22.7c0.6-1.4,0.9-2.9,0.9-4.5 C133.9,163.5,128.5,158,121.8,158L121.8,158z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st35",
  d: "M121.8,159.3c-6,0-10.9,4.9-10.9,11c0,1.6,0.3,3.1,1,4.5h20c0.6-1.4,1-2.9,1-4.5 C132.7,164.2,127.8,159.3,121.8,159.3L121.8,159.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M131.1,167.4c-1.6-5.2-7-8.1-12.2-6.6c-5.2,1.6-8.1,7-6.5,12.2L131.1,167.4z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M87.3,156.9c-6.7,0-12.2,5.5-12.2,12.3c0,2,0.5,4,1.4,5.7h21.6c0.9-1.7,1.4-3.6,1.4-5.7 C99.5,162.3,94.1,156.9,87.3,156.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st35",
  d: "M87.3,158.1c-6,0-10.9,4.9-10.9,11c0,2.1,0.6,4,1.6,5.7h18.8c1-1.6,1.6-3.6,1.6-5.7 C98.3,163,93.4,158.1,87.3,158.1L87.3,158.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M96.7,166.3c-1.6-5.2-7-8.1-12.2-6.6s-8.1,7-6.5,12.2L96.7,166.3z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M104.5,163.9c-6.3,0-11.4,4.7-12.1,10.8h24.2C115.9,168.7,110.8,163.9,104.5,163.9L104.5,163.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st35",
  d: "M104.5,165.2c-5.6,0-10.2,4.2-10.8,9.6h21.7C114.7,169.4,110.1,165.2,104.5,165.2L104.5,165.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M113.9,173.4c-1.6-5.2-7-8.1-12.2-6.6c-3.8,1.1-6.3,4.3-6.8,8h14.3L113.9,173.4z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M93.2,170.4c-3.8,0-7.1,1.7-9.3,4.4h18.7C100.3,172.1,96.9,170.4,93.2,170.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st35",
  d: "M93.2,171.7c-3,0-5.7,1.2-7.6,3.1h15.3C98.8,172.8,96.2,171.7,93.2,171.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M99,174.8c-2.4-1.8-5.6-2.4-8.6-1.5c-1.1,0.3-2.1,0.9-3,1.5H99z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M68.3,166.5c-5.3,0-9.9,3.5-11.5,8.3h23.1C78.2,170,73.7,166.5,68.3,166.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st35",
  d: "M68.3,167.8c-4.7,0-8.6,2.9-10.2,7h20.4C77,170.7,73,167.8,68.3,167.8L68.3,167.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M77.3,174.8c-2-4.4-7-6.9-11.7-5.4c-2.8,0.9-5,2.9-6.1,5.4H77.3L77.3,174.8z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M140.2,147c-6.7,0-12.2,5.5-12.2,12.3s5.5,12.3,12.2,12.3s12.2-5.5,12.2-12.3S147,147,140.2,147z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st35",
  d: "M140.2,148.3c-6,0-10.9,4.9-10.9,11s4.9,11,10.9,11s10.9-4.9,10.9-11S146.3,148.3,140.2,148.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M149.6,156.4c-1.6-5.2-7-8.1-12.1-6.6c-5.2,1.6-8.1,7-6.5,12.2L149.6,156.4L149.6,156.4z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M131,161.3c-6.7,0-12.2,5.5-12.2,12.3c0,0.4,0,0.8,0.1,1.2h24.3c0-0.4,0.1-0.8,0.1-1.2 C143.2,166.8,137.7,161.3,131,161.3L131,161.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st35",
  d: "M131,162.5c-6,0-10.9,4.9-10.9,11c0,0.4,0,0.8,0.1,1.2h21.7c0.1-0.4,0.1-0.8,0.1-1.2 C141.9,167.5,137,162.5,131,162.5L131,162.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M140.3,170.7c-1.6-5.2-7-8.1-12.1-6.6c-4.6,1.4-7.5,6-6.9,10.6h5.5L140.3,170.7L140.3,170.7z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M164.5,160.6c-6.7,0-12.2,5.5-12.2,12.3c0,0.6,0.1,1.3,0.1,1.9h24.1c0.1-0.6,0.1-1.3,0.1-1.9 C176.7,166.1,171.2,160.6,164.5,160.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st35",
  d: "M164.5,161.9c-6,0-10.9,4.9-10.9,11c0,0.6,0.1,1.3,0.2,1.9h21.6c0.1-0.6,0.2-1.3,0.2-1.9 C175.4,166.8,170.6,161.9,164.5,161.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M173.9,170.1c-1.6-5.2-7-8.1-12.1-6.6c-4.9,1.5-7.7,6.4-6.8,11.3h3.2L173.9,170.1L173.9,170.1z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M210.8,156.9c-6.7,0-12.2,5.5-12.2,12.3c0,2,0.5,4,1.4,5.7h21.6c0.9-1.7,1.4-3.6,1.4-5.7 C223,162.3,217.5,156.9,210.8,156.9L210.8,156.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st35",
  d: "M210.8,158.1c-6,0-10.9,4.9-10.9,11c0,2.1,0.6,4,1.6,5.7h18.8c1-1.6,1.6-3.6,1.6-5.7 C221.7,163,216.8,158.1,210.8,158.1L210.8,158.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M220.1,166.3c-1.6-5.2-7-8.1-12.1-6.6c-5.2,1.6-8.1,7-6.5,12.2L220.1,166.3L220.1,166.3z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M201,166.5c-5.4,0-9.9,3.5-11.5,8.3h23.1C210.9,170,206.3,166.5,201,166.5L201,166.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st35",
  d: "M201,167.8c-4.6,0-8.6,2.9-10.2,7h20.4C209.6,170.7,205.6,167.8,201,167.8L201,167.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M209.9,174.8c-2-4.4-7-6.9-11.7-5.4c-2.8,0.9-5,2.9-6.1,5.4H209.9L209.9,174.8z"
})));

var _ref82 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 105.6,
  y: 171.7,
  className: "st36",
  width: 22.4,
  height: 3.1
}), /*#__PURE__*/React.createElement("rect", {
  x: 121.8,
  y: 171.7,
  className: "st11",
  width: 6.2,
  height: 3.1
}), /*#__PURE__*/React.createElement("rect", {
  x: 106.2,
  y: 171.1,
  className: "st37",
  width: 21.1,
  height: 0.6
}));

var _ref83 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 104,
  y: 168.6,
  className: "st36",
  width: 22.4,
  height: 3.1
}), /*#__PURE__*/React.createElement("rect", {
  x: 120.2,
  y: 168.6,
  className: "st11",
  width: 6.2,
  height: 3.1
}), /*#__PURE__*/React.createElement("rect", {
  x: 104.7,
  y: 168,
  className: "st37",
  width: 21.1,
  height: 0.6
}));

var _ref84 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 108.1,
  y: 165.4,
  className: "st36",
  width: 22.4,
  height: 3.1
}), /*#__PURE__*/React.createElement("rect", {
  x: 124.3,
  y: 165.4,
  className: "st11",
  width: 6.2,
  height: 3.1
}), /*#__PURE__*/React.createElement("rect", {
  x: 108.7,
  y: 164.9,
  className: "st37",
  width: 21.1,
  height: 0.6
}));

var _ref85 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 106.4,
  y: 162.3,
  className: "st36",
  width: 22.4,
  height: 3.1
}), /*#__PURE__*/React.createElement("rect", {
  x: 122.6,
  y: 162.3,
  className: "st11",
  width: 6.2,
  height: 3.1
}), /*#__PURE__*/React.createElement("rect", {
  x: 107,
  y: 161.8,
  className: "st37",
  width: 21.1,
  height: 0.6
}));

var _ref86 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 146.8,
  y: 171.7,
  className: "st36",
  width: 22.4,
  height: 3.1
}), /*#__PURE__*/React.createElement("rect", {
  x: 163,
  y: 171.7,
  className: "st11",
  width: 6.2,
  height: 3.1
}), /*#__PURE__*/React.createElement("rect", {
  x: 147.4,
  y: 171.1,
  className: "st37",
  width: 21.1,
  height: 0.6
}));

var _ref87 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 145.2,
  y: 168.6,
  className: "st36",
  width: 22.4,
  height: 3.1
}), /*#__PURE__*/React.createElement("rect", {
  x: 161.4,
  y: 168.6,
  className: "st11",
  width: 6.2,
  height: 3.1
}), /*#__PURE__*/React.createElement("rect", {
  x: 145.8,
  y: 168,
  className: "st37",
  width: 21.1,
  height: 0.6
}));

var _ref88 = /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M68.8,175.7c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1S67.1,175.7,68.8,175.7L68.8,175.7z  M84.9,232.7c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1S83.2,232.7,84.9,232.7L84.9,232.7z M84.9,226.4 c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1S83.2,226.4,84.9,226.4L84.9,226.4z M84.9,220.1c1.7,0,3.1,1.4,3.1,3.1 s-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1S83.2,220.1,84.9,220.1L84.9,220.1z M84.9,213.7c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1S83.2,213.7,84.9,213.7L84.9,213.7z M84.9,207.4c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1 S83.2,207.4,84.9,207.4L84.9,207.4z M84.9,201c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1S83.2,201,84.9,201 L84.9,201z M84.9,194.7c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1S83.2,194.7,84.9,194.7L84.9,194.7z M84.9,188.4 c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1S83.2,188.4,84.9,188.4L84.9,188.4z M84.9,182c1.7,0,3.1,1.4,3.1,3.1 s-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1S83.2,182,84.9,182L84.9,182z M84.9,175.7c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1S83.2,175.7,84.9,175.7L84.9,175.7z M79.9,236.6c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1 S81.7,236.6,79.9,236.6L79.9,236.6z M73.7,236.6c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1S72,236.6,73.7,236.6 L73.7,236.6z M68.8,232.7c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1S70.5,232.7,68.8,232.7L68.8,232.7z  M68.8,226.4c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1S67.1,226.4,68.8,226.4L68.8,226.4z M68.8,220.1 c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1S67.1,220.1,68.8,220.1L68.8,220.1z M68.8,213.7c1.7,0,3.1,1.4,3.1,3.1 s-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1S67.1,213.7,68.8,213.7L68.8,213.7z M68.8,207.4c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1S67.1,207.4,68.8,207.4L68.8,207.4z M68.8,201c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1 S67.1,201,68.8,201L68.8,201z M68.8,194.7c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1S67.1,194.7,68.8,194.7 L68.8,194.7z M68.8,188.4c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1S67.1,188.4,68.8,188.4L68.8,188.4z M68.8,182 c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1S67.1,182,68.8,182z"
});

var _ref89 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M65.4,175.3c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1s-3.1,1.4-3.1,3.1S63.7,175.3,65.4,175.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M64.5,172.6c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2S63.9,172.6,64.5,172.6z"
}));

var _ref90 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M65.4,181.7c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1s-3.1,1.4-3.1,3.1S63.7,181.7,65.4,181.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M64.5,178.9c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2S63.9,178.9,64.5,178.9z"
}));

var _ref91 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M65.4,188c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1s-3.1,1.4-3.1,3.1S63.7,188,65.4,188z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M64.5,185.3c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2S63.9,185.3,64.5,185.3z"
}));

var _ref92 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M65.4,194.3c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1s-3.1,1.4-3.1,3.1S63.7,194.3,65.4,194.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M64.5,191.6c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2S63.9,191.6,64.5,191.6z"
}));

var _ref93 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M65.4,200.7c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1s-3.1,1.4-3.1,3.1S63.7,200.7,65.4,200.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M64.5,198c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2S63.9,198,64.5,198z"
}));

var _ref94 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M65.4,207c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1s-3.1,1.4-3.1,3.1S63.7,207,65.4,207z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M64.5,204.3c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2S63.9,204.3,64.5,204.3z"
}));

var _ref95 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M65.4,213.4c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1s-3.1,1.4-3.1,3.1S63.7,213.4,65.4,213.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M64.5,210.6c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2S63.9,210.6,64.5,210.6z"
}));

var _ref96 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M65.4,219.7c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1s-3.1,1.4-3.1,3.1S63.7,219.7,65.4,219.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M64.5,217c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2S63.9,217,64.5,217z"
}));

var _ref97 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M65.4,226c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1s-3.1,1.4-3.1,3.1S63.7,226,65.4,226z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M64.5,223.3c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2S63.9,223.3,64.5,223.3z"
}));

var _ref98 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M65.4,232.4c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1s-3.1,1.4-3.1,3.1S63.7,232.4,65.4,232.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M64.5,229.7c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2S63.9,229.7,64.5,229.7z"
}));

var _ref99 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M70.3,236.2c1.7,0,3.1-1.4,3.1-3.1S72,230,70.3,230s-3.1,1.4-3.1,3.1S68.6,236.2,70.3,236.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M69.4,233.5c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2S68.8,233.5,69.4,233.5z"
}));

var _ref100 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M76.6,236.2c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1s-3.1,1.4-3.1,3.1S74.8,236.2,76.6,236.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M75.7,233.5c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2S75,233.5,75.7,233.5z"
}));

var _ref101 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M81.6,175.3c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1s-3.1,1.4-3.1,3.1S79.8,175.3,81.6,175.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M80.7,172.6c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2S80,172.6,80.7,172.6z"
}));

var _ref102 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M81.6,181.7c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1s-3.1,1.4-3.1,3.1S79.8,181.7,81.6,181.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M80.7,178.9c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2S80,178.9,80.7,178.9z"
}));

var _ref103 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M81.6,188c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1s-3.1,1.4-3.1,3.1S79.8,188,81.6,188z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M80.7,185.3c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2S80,185.3,80.7,185.3z"
}));

var _ref104 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M81.6,194.3c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1s-3.1,1.4-3.1,3.1S79.8,194.3,81.6,194.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M80.7,191.6c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2S80,191.6,80.7,191.6z"
}));

var _ref105 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M81.6,200.7c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1s-3.1,1.4-3.1,3.1S79.8,200.7,81.6,200.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M80.7,198c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2S80,198,80.7,198z"
}));

var _ref106 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M81.6,207c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1s-3.1,1.4-3.1,3.1S79.8,207,81.6,207z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M80.7,204.3c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2S80,204.3,80.7,204.3z"
}));

var _ref107 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M81.6,213.4c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1s-3.1,1.4-3.1,3.1S79.8,213.4,81.6,213.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M80.7,210.6c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2S80,210.6,80.7,210.6z"
}));

var _ref108 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M81.6,219.7c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1s-3.1,1.4-3.1,3.1S79.8,219.7,81.6,219.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M80.7,217c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2S80,217,80.7,217z"
}));

var _ref109 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M81.6,226c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1s-3.1,1.4-3.1,3.1S79.8,226,81.6,226z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M80.7,223.3c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2S80,223.3,80.7,223.3z"
}));

var _ref110 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M81.6,232.4c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1s-3.1,1.4-3.1,3.1S79.8,232.4,81.6,232.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M80.7,229.7c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2S80,229.7,80.7,229.7z"
}));

var _ref111 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st29",
  points: "186.5,163.9 188.7,167.3 191,170.7 189.1,174.4 188.9,174.8 176.7,174.8 174.6,171.7 176.5,168  178.3,164.3 182.4,164.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st30",
  points: "185.1,166.6 186.5,168.7 187.9,170.9 186.8,173.2 186,174.8 179.9,174.8 179.1,173.6 177.7,171.5  178.9,169.2 180,166.9 182.5,166.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st31",
  points: "178.3,164.3 180,166.9 185.1,166.6 186.5,163.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st32",
  points: "178.3,164.3 174.6,171.7 177.7,171.5 180,166.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st32",
  points: "191,170.7 187.9,170.9 185.1,166.6 186.5,163.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st33",
  points: "191,170.7 188.9,174.8 186,174.8 187.9,170.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st33",
  points: "174.6,171.7 177.7,171.5 179.9,174.8 176.7,174.8  "
}));

var _ref112 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st29",
  points: "134,161.9 138.9,163.5 143.8,165.2 144.8,170.2 145.7,174.8 127.5,174.8 127.3,173.8 126.3,168.7  130.2,165.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st40",
  points: "134.8,165.7 137.9,166.7 140.9,167.7 141.5,170.9 142.2,174.1 141.4,174.8 130.9,174.8  130.6,173.1 130,169.9 132.4,167.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st41",
  points: "126.3,168.7 130,169.9 134.8,165.7 134,161.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st42",
  points: "126.3,168.7 127.5,174.8 130.9,174.8 130,169.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st42",
  points: "143.8,165.2 140.9,167.7 134.8,165.7 134,161.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st41",
  points: "143.8,165.2 145.7,174.8 144.3,174.8 142.2,174.1 140.9,167.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st43",
  points: "144.3,174.8 142.2,174.1 141.4,174.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "131.2,174.8 130.4,170.5 130.3,170.3 130.5,170.1 134.5,166.6 135.1,167.3 131.3,170.6  132.1,174.8  "
}));

var _ref113 = /*#__PURE__*/React.createElement("polygon", {
  className: "st40",
  points: "206.1,162.8 200,165.9 193.8,168.9 190.8,162.8 187.7,156.6  "
});

var _ref114 = /*#__PURE__*/React.createElement("polygon", {
  className: "st41",
  points: "201.5,161.3 197.7,165.1 193.8,168.9 193.1,163.5 192.3,158.1  "
});

var _ref115 = /*#__PURE__*/React.createElement("polygon", {
  className: "st41",
  points: "204.6,159.7 206.1,162.8 187.7,156.6 190.8,155.1  "
});

var _ref116 = /*#__PURE__*/React.createElement("polygon", {
  className: "st42",
  points: "192.3,158.1 191.6,156.6 190.8,155.1 189.3,155.8 187.7,156.6  "
});

var _ref117 = /*#__PURE__*/React.createElement("polygon", {
  className: "st42",
  points: "192.3,158.1 193.9,157.4 195.4,156.6 196.2,158.2 196.9,159.7  "
});

var _ref118 = /*#__PURE__*/React.createElement("polygon", {
  className: "st42",
  points: "201.5,161.3 200.8,159.7 200,158.2 198.5,158.9 196.9,159.7  "
});

var _ref119 = /*#__PURE__*/React.createElement("polygon", {
  className: "st42",
  points: "201.5,161.3 203.1,160.5 204.6,159.7 205.4,161.3 206.1,162.8  "
});

var _ref120 = /*#__PURE__*/React.createElement("polygon", {
  className: "st44",
  points: "192.3,158.1 190.8,158.9 189.3,159.7 188.5,158.1 187.7,156.6  "
});

var _ref121 = /*#__PURE__*/React.createElement("polygon", {
  className: "st44",
  points: "192.3,158.1 193.1,159.7 193.9,161.2 195.4,160.5 196.9,159.7  "
});

var _ref122 = /*#__PURE__*/React.createElement("polygon", {
  className: "st44",
  points: "201.5,161.3 200,162 198.4,162.8 197.7,161.2 196.9,159.7  "
});

var _ref123 = /*#__PURE__*/React.createElement("polygon", {
  className: "st44",
  points: "201.5,161.3 202.3,162.8 203,164.4 204.6,163.6 206.1,162.8  "
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M101.8,159.1c-0.9-0.3-1.6-1-1.8-1.9c-0.2,0.9-0.9,1.6-1.8,1.9c0.9,0.3,1.6,1,1.8,1.9 C100.2,160,100.9,159.3,101.8,159.1z"
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M111.4,150c-0.6-0.2-1.1-0.7-1.2-1.3c-0.2,0.6-0.6,1.1-1.2,1.3c0.6,0.2,1.1,0.7,1.2,1.3 C110.4,150.7,110.8,150.2,111.4,150z"
});

var _ref126 = /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M103.9,151.9c-1.5-0.5-2.7-1.7-3.1-3.2c-0.4,1.5-1.6,2.8-3.1,3.2c1.5,0.5,2.7,1.7,3.1,3.2 C101.2,153.5,102.4,152.3,103.9,151.9z"
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M117.8,160.3c-1.5-0.5-2.7-1.7-3.1-3.2c-0.4,1.5-1.6,2.8-3.1,3.2c1.5,0.5,2.7,1.7,3.1,3.2 C115.1,162,116.3,160.8,117.8,160.3z"
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M143.1,155.8c-1.5-0.5-2.7-1.7-3.1-3.2c-0.4,1.5-1.6,2.8-3.1,3.2c1.5,0.5,2.7,1.7,3.1,3.2 C140.4,157.5,141.6,156.2,143.1,155.8z"
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M136.1,150.7c-1-0.3-1.8-1.2-2.1-2.2c-0.3,1.1-1.1,1.9-2.1,2.2c1,0.3,1.8,1.2,2.1,2.2 C134.3,151.8,135.1,151,136.1,150.7z"
});

var _ref130 = /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M84,162.4c-1-0.3-1.8-1.2-2.1-2.2c-0.3,1.1-1.1,1.9-2.1,2.2c1,0.3,1.8,1.2,2.1,2.2 C82.2,163.5,83,162.7,84,162.4z"
});

var _ref131 = /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M93.8,167.2c-1.3-0.4-2.3-1.4-2.7-2.8c-0.3,1.3-1.4,2.4-2.7,2.8c1.3,0.4,2.3,1.4,2.7,2.8 C91.5,168.6,92.6,167.6,93.8,167.2z"
});

var _ref132 = /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M73.7,167.4c-1.3-0.4-2.3-1.4-2.7-2.8c-0.3,1.3-1.4,2.4-2.7,2.8c1.3,0.4,2.3,1.4,2.7,2.8 C71.4,168.8,72.4,167.8,73.7,167.4z"
});

var _ref133 = /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M60.4,172.7c-0.7-0.2-1.3-0.8-1.5-1.5c-0.2,0.7-0.8,1.3-1.5,1.5c0.7,0.2,1.3,0.8,1.5,1.5 C59.1,173.5,59.7,172.9,60.4,172.7z"
});

var _ref134 = /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M134,170.6c-1.3-0.4-2.3-1.4-2.6-2.8c-0.4,1.3-1.4,2.4-2.6,2.8c1.3,0.4,2.3,1.4,2.6,2.8 C131.7,172,132.7,171,134,170.6z"
});

var _ref135 = /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M137.4,162.3c-0.8-0.2-1.4-0.9-1.6-1.6c-0.2,0.8-0.8,1.4-1.6,1.6c0.8,0.2,1.4,0.9,1.6,1.6 C136,163.1,136.6,162.5,137.4,162.3z"
});

var _ref136 = /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M160.7,167.4c-0.8-0.2-1.4-0.9-1.6-1.6c-0.2,0.8-0.8,1.4-1.6,1.6c0.8,0.2,1.4,0.9,1.6,1.6 C159.3,168.2,159.9,167.6,160.7,167.4z"
});

var _ref137 = /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M159.7,159.4c-0.8-0.2-1.4-0.9-1.6-1.6c-0.2,0.8-0.8,1.4-1.6,1.6c0.8,0.2,1.4,0.9,1.6,1.6 C158.3,160.2,158.9,159.6,159.7,159.4z"
});

var _ref138 = /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M155,151.7c-0.8-0.2-1.4-0.9-1.6-1.6c-0.2,0.8-0.8,1.4-1.6,1.6c0.8,0.2,1.4,0.9,1.6,1.6 C153.6,152.6,154.2,151.9,155,151.7z"
});

var _ref139 = /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M181.1,160.4c-1.6-0.5-2.8-1.7-3.2-3.3c-0.4,1.6-1.6,2.9-3.2,3.3c1.6,0.5,2.8,1.7,3.2,3.3 C178.3,162.2,179.5,160.9,181.1,160.4z"
});

var _ref140 = /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M189,156.6c-0.6-0.2-1.1-0.7-1.3-1.3c-0.2,0.6-0.6,1.1-1.3,1.3c0.6,0.2,1.1,0.7,1.3,1.3 C187.9,157.3,188.4,156.8,189,156.6z"
});

var _ref141 = /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M194.4,160.8c-0.8-0.2-1.4-0.9-1.6-1.7c-0.2,0.8-0.8,1.5-1.6,1.7c0.8,0.2,1.4,0.9,1.6,1.7 C192.9,161.7,193.6,161.1,194.4,160.8z"
});

var _ref142 = /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M212.3,161.5c-1.5-0.5-2.7-1.7-3.1-3.2c-0.4,1.5-1.6,2.8-3.1,3.2c1.5,0.5,2.7,1.7,3.1,3.2 C209.6,163.2,210.8,162,212.3,161.5z"
});

var _ref143 = /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M207,170.1c-1.5-0.5-2.7-1.7-3.1-3.2c-0.4,1.5-1.6,2.8-3.1,3.2c1.5,0.5,2.7,1.7,3.1,3.2 C204.3,171.8,205.5,170.6,207,170.1z"
});

var _ref144 = /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M173,155.7c-0.6-0.2-1.1-0.7-1.3-1.3c-0.2,0.6-0.6,1.1-1.3,1.3c0.6,0.2,1.1,0.7,1.3,1.3 C171.9,156.4,172.4,155.9,173,155.7z"
});

var _ref145 = /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M139.1,228.2h1.8c0.4,0,0.8,0.4,0.8,0.8v8.9c0,0.4-0.4,0.8-0.8,0.8h-1.8c-0.4,0-0.8-0.4-0.8-0.8V229 C138.3,228.6,138.6,228.2,139.1,228.2z"
});

var _ref146 = /*#__PURE__*/React.createElement("rect", {
  x: 88.9,
  y: 180.7,
  className: "st9",
  width: 14.4,
  height: 2.6
});

var _ref147 = /*#__PURE__*/React.createElement("rect", {
  x: 173,
  y: 180.7,
  className: "st9",
  width: 16.3,
  height: 2.6
});

var _ref148 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M49.1,78.2c1.7,0,3.1,1,3.7,2.5h-7.4C46,79.2,47.4,78.2,49.1,78.2z"
});

var _ref149 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M50.8,80.6h-5.5c0.5-1.2,1.5-2.1,2.7-2.4C49.4,78.6,50.4,79.5,50.8,80.6L50.8,80.6z"
});

var _ref150 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M231.5,78.2c1.7,0,3.1,1,3.7,2.5h-7.4C228.4,79.2,229.8,78.2,231.5,78.2L231.5,78.2z"
});

var _ref151 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M232.9,80.6h-5.1c0.4-1.1,1.4-2,2.5-2.3C231.5,78.7,232.4,79.5,232.9,80.6z"
});

function SvgQ3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 279.7 279.7",
    style: {
      enableBackground: "new 0 0 279.7 279.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, _ref3, /*#__PURE__*/React.createElement("g", null, _ref4, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075129138739783310000000010108744634237514889_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000075129138739783310000000010108744634237514889_)"
    }
  }, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ3);
export default __webpack_public_path__ + "static/media/q3.286acab4abe15f647234553b2b00b5ef.svg";
export { ForwardRef as ReactComponent };